import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import * as actions from './ThemeApi';
import {getPublicUrl} from '../../../common/AppContextTools';

class ThemeProvider extends Component {

    state = {
        theme: null,
        ready: false,
    };

    componentDidMount() {
        if (this.props.themes.length === 0) {
            this.props.actions.getAvailableThemes();
        }
        const publicUrl = getPublicUrl();
        if (publicUrl) {
            this.props.actions.getClientTheme(publicUrl, profile => {
                this.setState({theme: profile.theme, ready: true});
            });
        } else {
            this.setState({ready: true});
        }
    }

    render() {
        const {themes, theme} = this.props;
        const stateClientTheme = this.state.theme;
        const ready = this.state.ready;
        const foundTheme = themes.find(t => t.name === theme);
        return (
            ready &&
            stateClientTheme ?
                <link rel='stylesheet' href={stateClientTheme} id='bootswatch-css' /> :
                foundTheme ?
                    <link rel='stylesheet' href={foundTheme.css} id='bootswatch-css' /> :
                    null
        );
    }
}

ThemeProvider.propTypes = {
    actions: PropTypes.object.isRequired,
    theme: PropTypes.string.isRequired,
    themes: PropTypes.array.isRequired,
};

ThemeProvider.defaultProps = {};

const mapStateToProps = ({appState}) => ({
    theme: appState.theme,
    clientTheme: appState.clientTheme,
    themes: appState.themes,
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(
        actions,
        dispatch),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(ThemeProvider);


// WEBPACK FOOTER //
// ./src/containers/template/theme/ThemeProvider.js